module.exports = __webpack_public_path__ + "03_freckles.466d779c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer2/03_freckles.png
// module id = 7TVv
// module chunks = 0